<template>
  <div class="information">
    <dl class="picture">
      <dt><img :src="basic_info.pic" alt="" class="img_img"></dt>
      <dd>
        <div class="picture_decoration">
          <p>Please upload a photo of yourself here. </p>
          <p>This photo will be used for your teacher profile page.</p>
          <p>Your photo should be professional, and have adequate lighting. Don't forget to smile!</p>
          <p>The photo may be in jpg or png formats, and the size should be 120 x 120.</p>
        </div>
        <div class="picture_sample">
          <div class="picture_img">
            <img src="~@img/user_img.jpg" alt="">
          </div>
          <p>Sample profile picture</p>
        </div>
      </dd>
    </dl>
    <div class="show_part">
      <ul class="part_list clearfix">
        <li>
          <p class="part_tit">First Name＊</p>
          <div class="part_cont">{{basic_info.first_name}}</div>
        </li>
        <li>
          <p class="part_tit">Last Name＊</p>
          <div class="part_cont">{{basic_info.last_name}}</div>
        </li>
        <li>
          <p class="part_tit">Teacher Name＊</p>
          <div class="part_cont">{{basic_info.nick_name}}</div>
        </li>
        <li>
          <p class="part_tit">Birthday＊</p>
          <div class="part_cont">{{basic_info.birthday}}</div>
        </li>
        <li>
          <p class="part_tit">Nationality＊</p>
          <div class="part_cont">{{selectShow.country}}</div>
        </li>
        <li>
          <p class="part_tit">Zoom account＊</p>
          <div class="part_cont">{{basic_info.zoom_id}}</div>
        </li>
        <li class="width490">
          <p class="part_tit">Skype ID</p>
          <div class="part_cont">{{basic_info.skype_id}}</div>
        </li>
        <li>
          <p class="part_tit">Computer's Operating Systerm＊</p>
          <div class="part_cont">{{basic_info.pc_type}}</div>
        </li>
        <li>
          <p class="part_tit">Country Code＊</p>
          <div class="part_cont">{{basic_info.country_code}}</div>
        </li>
        <li>
          <p class="part_tit">Phone Number＊</p>
          <div class="part_cont">{{basic_info.mobile}}</div>
        </li>
        <li>
          <p class="part_tit">Your Current Time Zone＊</p>
          <div class="part_cont">{{selectShow.time_zone}}</div>
        </li>
      </ul>
    </div>

    <div class="show_part">
      <h3 class="interests_tit">The country, state, and city you choose will automatically generate your time zone and zip code.</h3>
      <ul class="part_list clearfix">
        <li>
          <p class="part_tit">Country＊</p>
          <div class="part_cont">{{selectShow.country}}</div>
        </li>
        <li>
          <p class="part_tit">State＊</p>
          <div class="part_cont">{{changeShow.state}}</div>
        </li>
        <li>
          <p class="part_tit">City＊</p>
          <div class="part_cont">{{basic_info.city}}</div>
        </li>
        <li class="width490">
          <p class="part_tit">Street＊</p>
          <div class="part_cont">{{basic_info.street}}</div>
        </li>
        <li>
          <p class="part_tit">Zip Code＊</p>
          <div class="part_cont">{{basic_info.z_code}}</div>
        </li>
      </ul>
    </div>
    <div class="interest">
      <h3 class="interests_tit">The background and interests below will help our students get to know you better.</h3>
      <div class="item">
        <span class="item_left">Background＊</span>
        <ul class="background_list clearfix">
          <li v-for="(item, index) in background" class="active">{{item.name}}</li>
        </ul>
      </div>
      <div class="item">
        <span class="item_left">Interests＊</span>
        <ul class="background_list clearfix">
          <li v-for="(item, index) in interests" class="active">{{item.name}}</li>
        </ul>
      </div>
    </div>
    <p class="edit">
      <a href="javascript:;">Edit</a>
    </p>

  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      datas: '',
      dataShow: '',
      basic_info: {
        first_name: '',
        last_name: '',
        nick_name: '',
        birthday: '',
        country_code: '',
        mobile: '',
        zoom_id: '',
        city: '',
        street: '',
        z_code: '',
        skype_id: '',
        pic: '',
        pc_type: ''
      },
      selects: {
        pc_type: [
          {
            value: '1',
            label: 'Mac'
          },
          {
            value: '2',
            label: 'Windows'
          }
        ]
      },
      selectShow: {
        country: '',
        time_zone: ''
      },
      changeShow: {
        state: ''
      },
      background: [],
      interests: []
    }
  },
  created: function() {
    let _this = this
    /*请求基本信息*/

    // this.$http.get('/Boarding/getTutor')
    this.$http.get('/common/getConfig').then(
      function(response) {
        if (response.data && response.data.code == '75000') {
          _this.datas = response.data.res
          this.$http.get('/Boarding/getTutor').then(
            function(response) {
              // console.log(response.data.res.info);
              if (response.data && response.data.code == '75000') {
                this.dataShow = response.data.res.info
                // console.log(this.dataShow);
                for (var item in this.basic_info) {
                  //input的填写 名字之类的
                  this.basic_info[item] = this.dataShow[item]
                  if (this.dataShow.pc_type == '1') {
                    //判断选择电脑系统
                    this.basic_info.pc_type = 'Mac'
                  } else if (this.dataShow.pc_type == '2') {
                    this.basic_info.pc_type = 'Windows'
                  } else if (this.dataShow.pc_type == '0') {
                    this.basic_info.pc_type = ''
                  }
                }

                //有下拉的选项 国家和timeZone
                for (var key in this.selectShow) {
                  var naCode = this.dataShow[key]
                  var arrCode = this.datas[key]
                  if (naCode <= 0) {
                    this.selectShow[key] = ''
                  } else if (naCode > 0) {
                    this.selectShow[key] = arrCode[naCode]
                  }
                }
                _this.background = this.objBgActiveFn //渲染background
                _this.interests = this.objInterestsFn //渲染interests

                // 请求城市
                this.$http
                  .get(
                    '/common/getStatesByCountryId' +
                      '?country_id=' +
                      _this.dataShow.country
                  )
                  .then(
                    function(d) {
                      if ((d.data.code = 75000)) {
                        var stateShow = d.data.res
                        _this.changeShow.state = stateShow[this.dataShow.state]
                      }
                    },
                    function() {
                      console.log('error')
                    }
                  )
              }
            },
            function() {
              console.log('service error')
            }
          )
        }
      },
      function() {
        console.log('service error')
      }
    )
  },
  methods: {},
  computed: {
    objBgActiveFn: function() {
      var objBgActive = []
      if (this.dataShow.background == '') {
        objBgActive = []
      } else if (this.dataShow.background != '') {
        var arrBg = this.dataShow.background.split(',')
        //console.log(arrBg);
        for (var item in arrBg) {
          var key = arrBg[item]
          objBgActive.item = {
            name: this.datas.background[key]
          }
          objBgActive.push(objBgActive.item)
        }
      }
      return objBgActive
    },
    objInterestsFn: function() {
      var objBgActive = []
      if (this.dataShow.interests == '') {
        objBgActive = []
      } else if (this.dataShow.interests != '') {
        var arrBg = this.dataShow.interests.split(',')
        for (var item in arrBg) {
          var key = arrBg[item]
          objBgActive.item = {
            name: this.datas.interests[key]
          }
          objBgActive.push(objBgActive.item)
        }
      }
      return objBgActive
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.information {
  width: 1000px;
  p.state_notice {
    padding: 5px 0 5px 15px;
    color: #fd4c6e;
    font-size: 14px;
  }
  .picture {
    height: 140px;
    margin-bottom: 30px;
    dt {
      width: 162px;
      height: 140px;
      float: left;
      background-color: #fff9e5;
      text-align: center;
      .img_img {
        width: 120px;
        height: 120px;
        margin-top: 10px;
      }
    }
    dd {
      margin-left: 172px;
      background-color: #f7f7f7;
      height: 140px;
      padding-left: 28px;
      color: #525252;
      font-size: 14px;
      line-height: 17px;
    }
    .picture_decoration {
      padding-top: 28px;
      width: 552px;
      float: left;
      & > p:last-child {
        margin-top: 15px;
      }
    }
    .picture_sample {
      float: right;
      width: 244px;
      text-align: center;
      padding-top: 15px;
      & > p {
        line-height: 20px;
        font-size: 12px;
      }
      .picture_img {
        width: 90px;
        height: 90px;
        margin-left: 77px;
        margin-bottom: 5px;
        position: relative;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .show_part {
    li {
      width: 235px;
      float: left;
      margin-right: 20px;
      height: 82px;
      &.width490 {
        width: 490px;
        .part_cont {
          width: 468px;
        }
      }
    }
    .part_tit {
      height: 20px;
      font-size: 14px;
      color: #999;
    }
    .part_cont {
      width: 211px;
      height: 38px;
      line-height: 38px;
      border: 1px solid #ccc;
      border-radius: 10px;
      padding: 0 10px;
      overflow: hidden;
      font-size: 14px;
      color: #1e1e1e;
    }
  }
  .select_tipes {
    font-size: 14px;
    color: #fd4c6e;
    font-weight: bold;
    margin-top: 48px;
    margin-bottom: 30px;
  }
  .interest {
    font-size: 14px;
    margin-bottom: 50px;
    .interests_tit {
      margin-top: 0;
      font-size: 14px;
    }
    .item {
      padding-left: 103px;
      position: relative;
    }
    .item_left {
      position: absolute;
      left: 0;
      top: 10px;
      color: #525252;
    }
    .background_list {
      li {
        padding: 0 14px;
        height: 33px;
        line-height: 33px;
        margin-right: 10px;
        border: 1px solid #fcc800;
        color: #ffb400;
        margin-bottom: 25px;
        float: left;
        font-weight: bold;
        border-radius: 10px;
        cursor: pointer;
        &.active {
          background-color: #fcc800;
          color: #1e1e1e;
        }
      }
    }
  }
  .interests_tit {
    color: #525252;
    font-weight: bold;
    padding-top: 30px;
    margin-bottom: 30px;
    font-size: 14px;
  }
  .edit {
    text-align: center;
    margin-top: 80px;
    margin-bottom: 174px;
    a {
      width: 337px;
      height: 46px;
      line-height: 46px;
      font-size: 24px;
      display: inline-block;
      border: 1px solid #fcc800;
      color: #ffb400;
      border-radius: 10px;
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// info_pre.vue?589880f1